// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"6715d983","53":"82828ae1","82":"a3f2abc9","84":"af723fc2","180":"35a26b79","237":"4f60078e","277":"a5a0441f","308":"26527a59","453":"03346f77","467":"ee2a564e","595":"057f0f51","718":"009b83f2","783":"b4f1fc01","874":"b8b86afd","959":"950146ca"}[chunkId] + ".chunk.js";
};